import type { TaskActionRun } from "../persistence/records"

export function actionInputFingerprint(input: string): string {
    let left = 0x811c9dc5
    let right = 0x9e3779b9
    for (let index = 0; index < input.length; index += 1) {
        const code = input.charCodeAt(index)
        left = Math.imul(left ^ code, 0x01000193)
        right = Math.imul(right ^ code, 0x85ebca6b)
    }
    return `${input.length.toString(36)}-${(left >>> 0).toString(36)}-${(right >>> 0).toString(36)}`
}

export interface ActionRunCandidate {
    clientRequestId?: string
    inputFingerprint: string
}

export function providerActionInputFingerprint(input: string): string {
    // Fallback context is visible in native user input, but is not part of the
    // accepted Action's identity. Only remove the reserved leading envelope.
    const originalInput = input.replace(
        /^<system_instruction>\r?\n<session_context_update>[\s\S]*?<\/session_context_update>\r?\n<\/system_instruction>\r?\n(?:\r?\n)?/,
        ""
    )
    return actionInputFingerprint(originalInput)
}

export function matchTaskActionRuns(
    candidates: readonly ActionRunCandidate[],
    actionRuns: readonly TaskActionRun[],
    sessionId: string
): Array<TaskActionRun | null> {
    const available = actionRuns.filter((run) => run.sessionId === sessionId)
    const used = new Set<TaskActionRun>()
    const matches: Array<TaskActionRun | null> = candidates.map(() => null)

    candidates.forEach((candidate, index) => {
        if (!candidate.clientRequestId) return
        const run = available.findLast((item) => !used.has(item) && item.clientRequestId === candidate.clientRequestId)
        if (!run) return
        used.add(run)
        matches[index] = run
    })

    for (let index = candidates.length - 1; index >= 0; index -= 1) {
        if (matches[index]) continue
        const candidate = candidates[index]
        if (!candidate) continue
        const run = available.findLast((item) => !used.has(item) && item.inputFingerprint === candidate.inputFingerprint)
        if (!run) continue
        used.add(run)
        matches[index] = run
    }

    return matches
}
